import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  LESSON_FEATURE_KEY,
  LessonState,
  lessonAdapter,
} from './lesson.reducer';
import { selectSelectedDate } from '../plan/plan.selectors';
import { Lesson } from '@lyceo/shared/plan/util-models';
import { isSameDay } from 'date-fns';

export const selectLessonState =
  createFeatureSelector<LessonState>(LESSON_FEATURE_KEY);

const { selectAll } = lessonAdapter.getSelectors();

export const selectAllLessons = createSelector(
  selectLessonState,
  (state: LessonState) => selectAll(state),
);

export const selectLessonsBySelectedDate = createSelector(
  selectSelectedDate,
  selectAllLessons,
  (date: Date, lessons: Lesson[]) =>
    lessons.filter((lesson) => {
      if (lesson.scheduledDate) {
        return isSameDay(lesson.scheduledDate, date);
      }
      return false;
    }),
);
